import { render, staticRenderFns } from "./TalentPool.vue?vue&type=template&id=34fa8f02&"
import script from "./TalentPool.vue?vue&type=script&lang=js&"
export * from "./TalentPool.vue?vue&type=script&lang=js&"
import style0 from "./TalentPool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports